import React from 'react';
import { CTAButtonWrapper } from '../../../../common/styled-components/styled-components';
import Image from '../../../../../../app/js/components/loggedout/common/Image';
import * as S from './style';
import { CTAPrimaryButton } from '../../../../../../app/js/components/loggedout/shared-styles/CTAPrimaryButton';

import { Link } from 'react-router-dom';
import { codGrey } from '../../../../../../app/js/components/loggedout/shared-styles/Colors';
import Routes from '../../../../routes/routes';
import {featureList} from './data';
import ListItem from './list-item';
import ImacImage from './imac-section';
import AppleDownload from '~images/sem/apple-download.svg';
import GoogleDownload from '~images/sem/google-download.svg';

const FeaturesList = ({settings, trackPromoPageEvents}) => {
  let headingText = settings.trial_days ? `Start your ${settings.trial_days}-days free trial now!` : 'Subscribe Now';
  let ctaText = settings.trial_days ? `Try for free` : 'Subscribe Now';
  return (
    <S.ContainerWrapper noBackground={true}>
      <S.FeaturesWrapper>
      <S.HeadingText>{headingText}</S.HeadingText>
        <S.SubHeadingText>Plans start at just $5 per month</S.SubHeadingText>
        <S.ListWrapper>
          {
            featureList.map((item)=>
            <ListItem 
              item={item}
              fColor={codGrey}
              bulletColor={'#69D5C1'}
              />
            )
          }
        </S.ListWrapper>
        <CTAButtonWrapper>
          <CTAPrimaryButton darkBlue={true}>
            <Link to={Routes.PURCHASE_ROUTE} onClick={()=>trackPromoPageEvents("Promo Page Interacted", {'clicked_on' : 'CTA9'}, true)}>
              {ctaText}
            </Link>
          </CTAPrimaryButton>
        </CTAButtonWrapper>
      </S.FeaturesWrapper>
      <S.ImacSectionWrapper>
        <ImacImage />
        <S.AppDownloads>
          <Image src={AppleDownload} />
          <Image src={GoogleDownload} />
        </S.AppDownloads>
      </S.ImacSectionWrapper>
    </S.ContainerWrapper>
  )
}

export default FeaturesList;